const normalizeBaseUrl = (value: string) => value.replace(/\/+$/, "");

const ensureLeadingSlash = (path: string) =>
  path.startsWith("/") ? path : `/${path}`;

export const API_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_SERVER_URL || "",
);

const getRequiredApiBaseUrl = () => {
  if (API_BASE_URL) {
    return API_BASE_URL;
  }

  if (process.env.NODE_ENV === "production") {
    throw new Error(
      "REACT_APP_SERVER_URL is required for production builds and runtime API calls.",
    );
  }

  return "";
};

export const toApiUrl = (path: string) => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = ensureLeadingSlash(path);
  const baseUrl = getRequiredApiBaseUrl();

  return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath;
};

const DEFAULT_AI_PREDICT_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "/ai-predict"
    : "https://api.owlsociety.net";

export const AI_PREDICT_BASE_URL = normalizeBaseUrl(
  process.env.REACT_APP_AI_PREDICT_URL || DEFAULT_AI_PREDICT_BASE_URL,
);
